// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  width: fit-content;
  font-size: 16px !important;
  font-weight: 500;
}

.compact-item ion-icon {
  margin-inline-end: 14px !important;
}
.compact-item ion-label {
  margin-inline-start: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/popovers/configuration-popover/configuration-popover.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;AACF;;AAGE;EACE,kCAAA;AAAJ;AAGE;EACE,iCAAA;AADJ","sourcesContent":["ion-label {\n  width: fit-content;\n  font-size: 16px !important;\n  font-weight: 500;\n}\n// Compact spacing for popover items\n.compact-item {\n  ion-icon {\n    margin-inline-end: 14px !important;\n  }\n\n  ion-label {\n    margin-inline-start: 0 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
